import { insertBetween } from "@foretagsplatsen/core-helpers/array";
import AbstractMathFormulaVisitor from "./AbstractMathFormulaVisitor.js";

/**
 * `FormulaRendererVisitor` is a formula visitor used to produce a
 * renderable of the math formula.
 */
export default class FormulaRendererVisitor extends AbstractMathFormulaVisitor {
	formula(node) {
		return (html) => html.span(this.visit(node));
	}

	_add({ leftOperand, rightOperand }) {
		return (html) => html.span(leftOperand, " + ", rightOperand);
	}

	_subtract({ leftOperand, rightOperand }) {
		return (html) => html.span(leftOperand, " - ", rightOperand);
	}

	_multiply({ multiplicand, multiplier }) {
		return (html) => html.span(multiplicand, " × ", multiplier);
	}

	_divide({ dividend, divisor }) {
		return (html) => html.span(dividend, " / ", divisor);
	}

	_negated({ expression }) {
		return (html) => html.span("-", expression);
	}

	_text(text) {
		return `${text}`;
	}

	_link({ href, text }) {
		return (html) => html.a({ href }, text);
	}

	_or({ leftOperand, rightOperand }) {
		return (html) => html.span(leftOperand, " | ", rightOperand);
	}

	_wrapInParenthesis(...expression) {
		return (html) => html.span("(", ...expression, ") ");
	}

	_textWithOptions({ text, options }) {
		return (html) =>
			html.span(
				text,
				" (",
				...insertBetween({ array: options, separator: ", " }),
				") ",
			);
	}
}
